export enum StatisticsBrand {
    Essity = 'Essity',
    FemCare = 'FemCare',
    TenaConsumer = 'Tena Consumer',
    TenaProfessional = 'Tena Professional',
    Tork = 'Tork'
}
